module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-Demi.1a1c2c76.otf";